var handlerHistory = {
  $entries: $('.history-entry'),
  $timelineProgress: $('.timeline'),
  rearrangeEntries: function() {
    if (Foundation.MediaQuery.only('small')) {
      this.$entries.filter('.left-image').each(function() {
        $(this).children().eq(1).insertBefore($(this).children().eq(0));
      })  
    }
  },
  updateTimelineBar: function() {
    var $section = this.$entries.parents('#history-entries');
    var percentage = ($window.scrollTop() - $section.offset().top) / ($section.outerHeight() - $window.height()) * 100.0;
    percentage = Math.max(percentage, 0);
    percentage = Math.min(percentage,100);
    this.$timelineProgress.find('.line-progress').css('height', percentage+'%');
  }
};

jQuery(document).ready(function($) {
  if ($('#history-entries').length > 0) {
    handlerHistory.rearrangeEntries();
    $window
      .on("scroll", function() {
        handlerHistory.updateTimelineBar();
      });
  }
});

